import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
import InsightCardWrapperStyled from '../styled-components/InsightCardWrapperStyled';
import 'react-loading-skeleton/dist/skeleton.css';
import { device } from '../../../utils/styled-component-mixins';

const SkeletonCardWrapper = styled.div`
  .featured-card-image {
    display: none;

    @media ${device.desktop} {
      display: block;
      height: 32.6rem;
      padding-bottom: 0 !important;
    }

    .react-loading-skeleton {
      border-radius: 0;
      line-height: 3.2rem;
    }
  }

  .featured-card-content {
    height: 31.2rem !important;
  }

  .animation-wrapper {
    flex-direction: column !important;
    justify-content: space-between !important;
    align-items: flex-start !important;

    .animated-content {
      margin: 0 !important;
      position: static !important;
      width: 100% !important;
    }

    a {
      transform: translateX(0) !important;
    }
  }

  .content-wrapper {
    width: 100% !important;
  }
`;

const SkeletonCard = () => (
  <SkeletonCardWrapper>
    <InsightCardWrapperStyled className="insight-card-wrapper">
      <div className="insight-card insight-card-standard">
        <div className="featured-card-image">
          <Skeleton width="100%" height="100%" />
        </div>
        <div className="featured-card-content">
          <div className="animation-wrapper mounted">
            <div className="content-wrapper">
              <div className="animated-content">
                <h3>
                  <Skeleton count={2} width="100%" height="100%" />
                </h3>
                <p>
                  <Skeleton />
                </p>
              </div>
            </div>
            <div className="overflow-wrapper">
              <a>
                <span>
                  <Skeleton width="100px" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </InsightCardWrapperStyled>
  </SkeletonCardWrapper>
);

export default SkeletonCard;
